const ValidateForm = {
  defaultContent: {
    available: '<span>Adicionar ao carrinho</span>',
    unavailable: '<span>Produto indisponível</span>',
    selection: '<span>Escolha 1 opção de cada característica</span>'
  },

  // Valida se foi feita uma seleção para todos os atributos existentes em tela
  validateAllSelected: function(form) {

    const allInputs = {
      attr1: [...form.querySelectorAll('[data-attribute="1"] input')],
      attr2: [...form.querySelectorAll('[data-attribute="2"] input')],
      attr3: [...form.querySelectorAll('[data-attribute="3"] input')],
    };

    const selectedInputs = {
      attr1: form.querySelector('[data-attribute="1"] input:checked'),
      attr2: form.querySelector('[data-attribute="2"] input:checked'),
      attr3: form.querySelector('[data-attribute="3"] input:checked'),
    };

    let attr1pass = allInputs.attr1.length === 0
    let attr2pass = allInputs.attr2.length === 0
    let attr3pass = allInputs.attr3.length === 0

    if (!attr1pass && selectedInputs.attr1) {
      attr1pass = true
    }

    if (!attr2pass && selectedInputs.attr2) {
      attr2pass = true
    }

    if (!attr3pass && selectedInputs.attr3) {
      attr3pass = true
    }

    return attr1pass && attr2pass && attr3pass
    
  },

  setSelection: function(form, variant) {
    const addButton = form.querySelector('[data-action="add-cart"]');
    const productContainer = form.closest('[data-product-box]');
    let formNotify = null;

    if (productContainer) {
      formNotify = productContainer.querySelector('[data-form-notify]');
    }

    if (addButton) {
      const textContent = addButton.getAttribute('data-text-selection') || ValidateForm.defaultContent.selection
      addButton.setAttribute('data-available', false);
      addButton.classList.remove('-available');
      addButton.classList.add('-unavailable');
      addButton.innerHTML = textContent;
    }

    if (formNotify) formNotify.classList.remove('-active');
  },

  setAvailable: function(form, variant) {
    const addButton = form.querySelector('[data-action="add-cart"]');
    const productContainer = form.closest('[data-product-box]');
    const hasPreSale = productContainer ? productContainer.classList.contains('-pre-sale') : false;
    let formNotify = null;

    if (productContainer) {
      formNotify = productContainer.querySelector('[data-form-notify]');
    }

    if (addButton) {
      const textContent = addButton.getAttribute('data-text-available') || ValidateForm.defaultContent.available;
      const textPreSale = addButton.getAttribute('data-text-pre-sale') || ValidateForm.defaultContent.available;
      addButton.setAttribute('data-available', true);
      addButton.classList.add('-available');
      addButton.classList.remove('-unavailable');
      if(productContainer && hasPreSale) {
        addButton.innerHTML = textPreSale;
      } else {
        addButton.innerHTML = textContent;
      } 
    }

    if (formNotify) {
      formNotify.classList.remove('-active');
    }
  },

  setUnavailable: function(form, variant) {
    const addButton = form.querySelector('[data-action="add-cart"]');
    const productContainer = form.closest('[data-product-box]');
    let formNotify = null;

    if (productContainer) {
      formNotify = productContainer.querySelector('[data-form-notify]');
    }

    if (addButton) {
      const textContent = addButton.getAttribute('data-text-unavailable') || ValidateForm.defaultContent.unavailable;
      addButton.setAttribute('data-available', false);
      addButton.classList.remove('-available');
      addButton.classList.add('-unavailable');
      addButton.innerHTML = textContent;
    }

    if (formNotify) {
      if (variant.sku) {
        formNotify.classList.add('-active');
        formNotify.querySelector('[name="sku"]').value = variant.sku;
      } else {
        formNotify.classList.remove('-active');
      }
    }
  },

  validate: function(form, variant) {
    if (!form) return

    const attrsValidated = ValidateForm.validateAllSelected(form)
    if (!attrsValidated) {
      return ValidateForm.setSelection(form, variant)
    }

    if (!variant) {
      console.error('ValidateForm: não existe variante para a seleção de atributos feita.')
      return ValidateForm.setSelection(form, variant)
    }

    if (variant.available && variant.stock > 0) {
      ValidateForm.setAvailable(form, variant)
    } else {
      ValidateForm.setUnavailable(form, variant)
    }
  }
}

export default ValidateForm
